import { createContext } from "react";
import type { Vel } from "@/types/Vel";

export const VelContext = createContext<Vel[] | null>(null);
